<template>
  <div>
    <div class="card">

      <h1>Politique de confidentialité</h1>
      <p>La présente Politique de confidentialité décrit la façon dont vos informations personnelles sont recueillies, utilisées et partagées lorsque vous vous rendez sur https://www.sv-quiz.fr (le « Site »).</p>

      <h2>Informations personnelles receuillies</h2>
      <p>Lorsque vous vous rendez sur le Site, nous recueillons automatiquement certaines informations concernant votre appareil, notamment des informations sur votre navigateur web, votre adresse IP, votre fuseau horaire et certains des cookies qui sont installés sur votre appareil. En outre, lorsque vous parcourez le Site, nous recueillons des informations sur la manière dont vous interagissez avec le Site. Nous désignons ces informations collectées automatiquement sous l'appellation « Informations sur l'appareil ».</p>
      <p>Nous recueillons les Informations sur l'appareil à l'aide des technologies suivantes :</p>
      <p>- Les « fichiers journaux » suivent l'activité du Site et recueillent des données telles que votre adresse IP, le type de navigateur que vous utilisez, votre fournisseur d'accès Internet, et vos données d'horodatage (date et heure).</p>
      <p>- Les « pixels invisibles », les « balises » et les « pixels » sont des fichiers électroniques qui enregistrent des informations sur la façon dont vous parcourez le Site.</p>
      <p>Lorsque nous utilisons l'expression « Informations personnelles » dans la présente Politique de confidentialité, nous faisons allusion à la fois aux Informations sur l'appareil.</p>

      <h2>Comment utilisons-nous vos informations personnelles ?</h2>
      <p>Nous utilisons ces Informations sur la commande pour : communiquer avec vous, et évaluer les fraudes ou risques potentiels.</p>
      <p>Nous utilisons les Informations sur l'appareil (en particulier votre adresse IP) que nous recueillons pour évaluer les fraudes ou risques potentiels et, de manière plus générale, pour améliorer et optimiser notre Site (par exemple, en générant des analyses sur la façon dont nos clients parcourent et interagissent avec le Site.</p>

      <h2>Partage de vos informations personnelles</h2>
      <p>Aucune de vos informations personnelle n'est partagée avec un tier.</p>
      <p>Cependant, il se peut que nous partagions aussi vos Informations personnelles pour respecter les lois et règlementations applicables, répondre à une assignation, à un mandat de perquisition ou à toute autre demande légale de renseignements que nous recevons, ou pour protéger nos droits.</p>

      <h2>Vos droits</h2>
      <p>Si vous êtes résident(e) européen(ne), vous disposez d'un droit d'accès aux informations personnelles que nous détenons à votre sujet et vous pouvez demander à ce qu'elles soient corrigées, mises à jour ou supprimées. Si vous souhaitez exercer ce droit, veuillez nous contacter au moyen des coordonnées précisées ci-dessous.</p>

      <h2>Rétention des données</h2>
      <p>Lorsque vous utilisez le site, nous conservons vos données dans nos dossiers, sauf si et jusqu'à ce que vous nous demandiez de les supprimer.</p>

      <h2>Changements</h2>
      <p>Nous pouvons être amenés à modifier la présente politique de confidentialité de temps à autre afin d'y refléter, par exemple, les changements apportés à nos pratiques ou pour d'autres motifs opérationnels, juridiques ou réglementaires.</p>

      <h2>Nous contacter</h2>
      <p>Pour en savoir plus sur nos pratiques de confidentialité, si vous avez des questions ou si vous souhaitez déposer une réclamation, veuillez nous contacter par e-mail à <a href="mailto:contact@sv-quiz.fr">contact@sv-quiz.fr</a>.</p>

    </div>
  </div>
</template>

<style scoped>
.card {
  width: 70%;
  margin-left: auto;
  margin-right: auto;
}
h1 {
  font-size: 32px;
  margin: 20px 0 30px;
  text-align: center;
}
h2 {
  font-size: 26px;
  margin: 25px 0 12px;
}
h3 {
  font-size: 22px;
  margin: 12px 0 7px;
}
p {
  text-align: justify;
  margin: 0 35px 7px;
}

@media screen and (max-width: 1400px) {
  .card {
    width: 85%;
  }
  p {
    margin: 0 25px 7px;
  }
}
@media screen and (max-width: 720px) {
  .card {
    width: 96%;
  }
  p {
    margin: 0 12px 7px;
  }
}
</style>
<script>
export default {
  mounted() {
    window.scrollTo(0, 0)
  }
}
</script>